(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eldaly-brands"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var wrap = document.querySelector('[data-eldaly-brands-wrap]');
    if (!wrap) return;
    var loopWidth = wrap.scrollWidth / 2;
    function init() {
      loopWidth = wrap.scrollWidth / 2;
      var first = wrap.querySelector('.eldaly-brands__item');
      var itemW = first ? first.getBoundingClientRect().width : 280;
      wrap.scrollLeft = loopWidth - (wrap.getBoundingClientRect().width / 2 - itemW / 2);
    }
    requestAnimationFrame(function () { setTimeout(init, 100); });
    window.addEventListener('resize', init);

    var raf = null, speed = 0.8;
    function auto() { wrap.scrollLeft += speed; if (wrap.scrollLeft >= loopWidth) wrap.scrollLeft -= loopWidth; else if (wrap.scrollLeft <= 0) wrap.scrollLeft += loopWidth; raf = requestAnimationFrame(auto); }
    function start() { if (!raf) raf = requestAnimationFrame(auto); }
    function stop() { if (raf) { cancelAnimationFrame(raf); raf = null; } }
    start();

    var dragging = false, startX = 0, startScroll = 0, dist = 0;
    wrap.addEventListener('mousedown', function (e) { dragging = true; dist = 0; startX = e.pageX - wrap.offsetLeft; startScroll = wrap.scrollLeft; stop(); wrap.classList.add('is-grabbing'); });
    window.addEventListener('mousemove', function (e) { if (!dragging) return; e.preventDefault(); var x = e.pageX - wrap.offsetLeft; var walk = (x - startX) * 2; dist = Math.abs(walk); wrap.scrollLeft = startScroll - walk; });
    window.addEventListener('mouseup', function () { if (!dragging) return; dragging = false; wrap.classList.remove('is-grabbing'); start(); });
    wrap.addEventListener('mouseenter', stop);
    wrap.addEventListener('mouseleave', function () { if (!dragging) start(); });
    wrap.addEventListener('touchstart', stop, { passive: true });
    wrap.addEventListener('touchend', function () { setTimeout(start, 2000); }, { passive: true });
    wrap.addEventListener('click', function (e) { if (dist > 4) { e.preventDefault(); e.stopPropagation(); } }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eldaly-category-scroll"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-eldaly-cat-scroll]');
    if (!root) return;
    var section = root.closest('.eldaly-cat');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-eldaly-cat-card]'));
    if (!cards.length) return;

    // Triple the cards for an infinite loop
    var html = root.innerHTML;
    root.innerHTML = html + html + html;
    var third = 0;

    function measure() { third = root.scrollWidth / 3; }

    var velocity = 0, rafMomentum = null, auto = null, interacting = false, resumeTimer = null;
    var dragging = false, didDrag = false, startX = 0, startScroll = 0, lastX = 0, lastTime = 0;

    function clamp() {
      measure();
      if (root.scrollLeft < third * 0.5) root.scrollLeft += third;
      else if (root.scrollLeft >= third * 2.5) root.scrollLeft -= third;
    }
    function stopMomentum() { if (rafMomentum) { cancelAnimationFrame(rafMomentum); rafMomentum = null; } }
    function momentum() {
      velocity *= 0.92;
      if (Math.abs(velocity) < 0.5) { velocity = 0; return; }
      root.scrollLeft += velocity;
      clamp();
      rafMomentum = requestAnimationFrame(momentum);
    }
    function startAuto() {
      stopAuto();
      auto = setInterval(function () {
        if (interacting) return;
        root.scrollLeft += 1.2;
        clamp();
      }, 16);
    }
    function stopAuto() { if (auto) { clearInterval(auto); auto = null; } }
    function pause() {
      interacting = true;
      if (resumeTimer) clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () { interacting = false; }, 2500);
    }

    function down(x) { stopMomentum(); pause(); dragging = true; didDrag = false; startX = x; startScroll = root.scrollLeft; lastX = x; lastTime = Date.now(); velocity = 0; if (section) section.classList.add('is-grabbing'); }
    function move(x) {
      if (!dragging) return;
      var dx = x - startX;
      if (Math.abs(dx) > 4) didDrag = true;
      var now = Date.now(), dt = now - lastTime;
      if (dt > 0) velocity = (x - lastX) / dt * 16;
      lastX = x; lastTime = now;
      root.scrollLeft = startScroll - dx;
      clamp();
    }
    function up() {
      if (!dragging) return;
      dragging = false;
      if (section) section.classList.remove('is-grabbing');
      if (Math.abs(velocity) > 1) { velocity = -velocity; momentum(); }
    }

    root.addEventListener('mousedown', function (e) { e.preventDefault(); down(e.clientX); });
    window.addEventListener('mousemove', function (e) { move(e.clientX); });
    window.addEventListener('mouseup', up);
    root.addEventListener('touchstart', function (e) { down(e.touches[0].clientX); }, { passive: true });
    root.addEventListener('touchmove', function (e) { move(e.touches[0].clientX); }, { passive: true });
    root.addEventListener('touchend', up);
    root.addEventListener('click', function (e) { if (didDrag) { e.preventDefault(); e.stopPropagation(); } }, true);

    // Initialise at middle set, start auto-scroll
    requestAnimationFrame(function () { measure(); root.scrollLeft = third; startAuto(); });
    window.addEventListener('resize', function () { measure(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eldaly-featured-watches"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function shuffle(a) {
      for (var i = a.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = a[i]; a[i] = a[j]; a[j] = t;
      }
      return a;
    }

    // Re-shuffle + re-interleave a tab's pool every 10s (matches React's ProductTabs).
    function setupReshuffle(root) {
      var grid = root.querySelector('[data-eldaly-grid]');
      var pool = root.querySelector('[data-eldaly-pool]');
      if (!grid) return;

      var all = Array.prototype.slice.call(grid.querySelectorAll('.eldaly-card'));
      if (pool) all = all.concat(Array.prototype.slice.call(pool.querySelectorAll('.eldaly-card')));
      var mens = all.filter(function (c) { return c.getAttribute('data-gender') === 'men'; });
      var womens = all.filter(function (c) { return c.getAttribute('data-gender') === 'women'; });
      if (!mens.length && !womens.length) return;

      // Park every card in the pool; the grid will be filled by refresh().
      mens.concat(womens).forEach(function (c) { if (pool) pool.appendChild(c); });

      function refresh() {
        // Move any cards currently in the grid back to the pool first.
        Array.prototype.slice.call(grid.querySelectorAll('.eldaly-card'))
          .forEach(function (c) { if (pool) pool.appendChild(c); });

        var pm = shuffle(mens.slice()).slice(0, 6);
        var pw = shuffle(womens.slice()).slice(0, 6);
        var max = Math.max(pm.length, pw.length);
        var frag = document.createDocumentFragment();
        for (var i = 0; i < max; i++) {
          if (i < pm.length) frag.appendChild(pm[i]);
          if (i < pw.length) frag.appendChild(pw[i]);
        }
        grid.appendChild(frag);
      }

      refresh();
      setInterval(refresh, 10000);
    }

    document.querySelectorAll('[data-eldaly-tabs]:not([data-eldaly-tabs-bound])').forEach(function (root) {
      root.setAttribute('data-eldaly-tabs-bound', '');

      // Tab switching
      var btns = root.querySelectorAll('[data-eldaly-tab]');
      var panels = root.querySelectorAll('[data-eldaly-panel]');
      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var i = btn.getAttribute('data-eldaly-tab');
          btns.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-eldaly-panel') === i); });
        });
      });

      // 10-second men/women re-shuffle for each panel
      panels.forEach(function (panel) { setupReshuffle(panel); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eldaly-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var header = document.getElementById('eldaly-header');
    if (header) {
      var ticking = false;
      var onScroll = function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var y = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
          if (y > 0) header.classList.add('is-scrolled');
          else header.classList.remove('is-scrolled');
          ticking = false;
        });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      document.addEventListener('scroll', onScroll, { passive: true, capture: true });
      onScroll();
    }

    // Mega menu hover with debounce
    var triggers = header ? header.querySelectorAll('[data-mega-trigger]') : [];
    var panels = header ? header.querySelectorAll('[data-mega-panel]') : [];
    var closeTimer = null;
    var current = null;

    function openPanel(key) {
      panels.forEach(function (p) {
        if (p.getAttribute('data-mega-panel') === key) p.classList.add('is-open');
        else p.classList.remove('is-open');
      });
      current = key;
    }
    function closeAll() {
      panels.forEach(function (p) { p.classList.remove('is-open'); });
      current = null;
    }

    triggers.forEach(function (t) {
      var key = t.getAttribute('data-mega-trigger');
      t.addEventListener('mouseenter', function () {
        if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
        openPanel(key);
      });
      t.addEventListener('mouseleave', function () {
        closeTimer = setTimeout(closeAll, 250);
      });
    });
    panels.forEach(function (p) {
      p.addEventListener('mouseenter', function () {
        if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      });
      p.addEventListener('mouseleave', function () {
        closeTimer = setTimeout(closeAll, 250);
      });
    });

  // Active dock tab
  var path = window.location.pathname;
  var isHome = path === '/' || path === '' || /^\/[a-z]{2}(\/)?$/.test(path);
  document.querySelectorAll('[data-dock-tab]').forEach(function (tab) {
    var k = tab.getAttribute('data-dock-tab');
    if ((k === 'home' && isHome) || (k === 'liked' && path.indexOf('liked') > -1)) {
      tab.classList.add('is-active');
    }
  });

  // Mobile dock morph: "Explore Collection" CTA on home (not scrolled) -> capsule on scroll
  var dock = document.querySelector('[data-eldaly-dock]');
  function updateDock() {
    if (!dock) return;
    var scrolled = window.scrollY > 5;
    if (isHome && !scrolled) dock.classList.add('is-explore');
    else dock.classList.remove('is-explore');
  }
  if (dock) {
    window.addEventListener('scroll', updateDock, { passive: true });
    updateDock();
    var exploreEl = dock.querySelector('[data-eldaly-explore]');
    if (exploreEl) {
      dock.addEventListener('click', function (e) {
        if (dock.classList.contains('is-explore')) {
          e.preventDefault();
          window.scrollTo({ top: window.innerHeight * 0.85, behavior: 'smooth' });
        }
      });
    }
  }

  // Product page dock buttons -> dispatch events to product section
  var dockBuyNow = document.querySelector('[data-dock-buynow]');
  var dockAtc = document.querySelector('[data-dock-atc]');
  if (dockBuyNow) dockBuyNow.addEventListener('click', function() {
    window.dispatchEvent(new CustomEvent('eldaly-dock-buynow'));
  });
  if (dockAtc) dockAtc.addEventListener('click', function() {
    window.dispatchEvent(new CustomEvent('eldaly-dock-atc'));
  });

  // Mobile drawer
  var drawer = document.querySelector('[data-eldaly-drawer]');
  if (drawer) {
    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('data-panel', 'main');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      drawer.classList.remove('is-open');
      if (document.activeElement && drawer.contains(document.activeElement)) {
        document.activeElement.blur();
      }
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      setTimeout(function () { drawer.setAttribute('data-panel', 'main'); }, 250);
    }
    document.querySelectorAll('[data-eldaly-drawer-open]').forEach(function (b) {
      b.addEventListener('click', openDrawer);
    });
    document.querySelectorAll('[data-eldaly-drawer-close]').forEach(function (b) {
      b.addEventListener('click', closeDrawer);
    });
    drawer.querySelectorAll('[data-eldaly-panel-trigger]').forEach(function (b) {
      b.addEventListener('click', function () {
        drawer.setAttribute('data-panel', b.getAttribute('data-eldaly-panel-trigger'));
      });
    });
    drawer.querySelectorAll('[data-eldaly-back]').forEach(function (b) {
      b.addEventListener('click', function () { drawer.setAttribute('data-panel', 'main'); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });
  }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eldaly-women-accessories"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function shuffle(a) {
      for (var i = a.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = a[i]; a[i] = a[j]; a[j] = t;
      }
      return a;
    }

    // Re-shuffle a tab's pool every 10s (matches React's BagsTabs setInterval).
    function setupReshuffle(panel) {
      var grid = panel.querySelector('[data-wa-grid]');
      var pool = panel.querySelector('[data-wa-pool]');
      if (!grid) return;

      var all = Array.prototype.slice.call(grid.querySelectorAll('.eldaly-card'));
      if (pool) all = all.concat(Array.prototype.slice.call(pool.querySelectorAll('.eldaly-card')));
      if (!all.length) return;

      // Park every card in the pool; the grid will be filled by refresh().
      all.forEach(function (c) { if (pool) pool.appendChild(c); });

      function refresh() {
        Array.prototype.slice.call(grid.querySelectorAll('.eldaly-card'))
          .forEach(function (c) { if (pool) pool.appendChild(c); });
        var picked = shuffle(all.slice()).slice(0, 12);
        var frag = document.createDocumentFragment();
        picked.forEach(function (c) { frag.appendChild(c); });
        grid.appendChild(frag);
      }

      refresh();
      setInterval(refresh, 10000);
    }

    document.querySelectorAll('[data-eldaly-wa-tabs]:not([data-wa-bound])').forEach(function (root) {
      root.setAttribute('data-wa-bound', '');

      var btns = root.querySelectorAll('[data-wa-tab]');
      var panels = root.querySelectorAll('[data-wa-panel]');
      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var i = btn.getAttribute('data-wa-tab');
          btns.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-wa-panel') === i); });
        });
      });

      panels.forEach(function (panel) { setupReshuffle(panel); });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
